module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('sensorOlRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange3))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "graph",
    attrs: {
      "id": "img3_1"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.A),
      expression: "show.A"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_1.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[0]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.B),
      expression: "show.B"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_2.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.C),
      expression: "show.C"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_3.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.legendDate[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.D),
      expression: "show.D"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_4.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[3]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.E),
      expression: "show.E"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_5.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[4]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.F),
      expression: "show.F"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_6.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[5]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.G),
      expression: "show.G"
    }],
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Line_7.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.legendDate[6]))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Average.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Average')))])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('ofhypo')))])]), _vm._v(" "), _vm._l((_vm.date), function(item, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item),
        expression: "item"
      }]
    }, [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].avg))]), _vm._v(" "), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].min))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(_vm.glucose[i].max))]), _vm._v(" "), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(_vm.glucose[i].nh))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('overall')))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].min))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].max))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.glucose[_vm.glucoseLength].nh))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18311ebd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart3_print.vue
// module id = 1419
// module chunks = 7